import { Flex, Spacing } from '@billy/design-system'
import { useCallback } from 'react'

import { useAttachmentsCounter } from '@features/attachments/hooks/useAttachmentsCounter'
import { UploadsTabs } from '@views/receipts/elements/UploadsTabs'
import { useReceiptsTabs } from '@views/receipts/hooks/useReceiptsTabs'

import { AttachmentFilterType } from '../../../../enums/attachmentFiltertype'
import {
  defaultChooseAttachmentModalFilters,
  useChooseAttachmentModal,
} from '../../contexts/chooseAttachmentModalContext'
import { SearchAction } from './elements/SearchAction'
import { SortAction } from './elements/SortActions/SortAction'
import * as Styled from './styles'

export const ModalActions = () => {
  const { filters, setFilters } = useChooseAttachmentModal()
  const { hasReceivedEInvoices, isLoading: isCountLoading, countMap } = useAttachmentsCounter({ enabled: true })
  const tabs = useReceiptsTabs({
    hasReceivedEInvoices,
  })

  const handleTabClick = useCallback(
    (type: AttachmentFilterType) => () => {
      setFilters({ type, page: defaultChooseAttachmentModalFilters.page })
    },
    [setFilters],
  )

  return (
    <Styled.ModalActionsWrapper>
      <Flex justifyContent="space-between">
        <UploadsTabs
          tabs={tabs}
          countMap={countMap}
          isCountLoading={isCountLoading}
          selectedTab={filters.type}
          handleTabClick={handleTabClick}
        />
        <Styled.RightActionsWrapper>
          <Flex gap={Spacing.S16}>
            <SearchAction />
            <SortAction />
          </Flex>
        </Styled.RightActionsWrapper>
      </Flex>
    </Styled.ModalActionsWrapper>
  )
}
